<atn-ds-page>
  <atn-ds-page-header
    pageHeader
    [name]="tenantNameSg()"
    [breadcrumbs]="breadcrumbsSg()"
  />
  <atn-ds-floating-horizontal-tabs>
    <ng-template
      atnDsTab
      name="General"
    >
      <atn-admin-tenant-page-general-tab />
    </ng-template>

    <ng-template
      atnDsTab
      name="Zones"
    >
      <atn-admin-tenant-page-zones-tab />
    </ng-template>

    @if (canManageUsersSg()) {
      <ng-template
        atnDsTab
        name="Users"
      >
        <atn-admin-tenant-page-users-tab />
      </ng-template>
    }

    @if (canManageUsersSg()) {
      <ng-template
        atnDsTab
        name="Agents"
      >
        <atn-admin-tenant-page-agents-tab />
      </ng-template>
    }
  </atn-ds-floating-horizontal-tabs>
</atn-ds-page>
